import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { TranslatePipe } from 'i18n';
import { FunnelShellComponent } from '../funnel-shell/funnel-shell.component';

@Component({
  selector: 'app-funnel-check-email-page',
  standalone: true,
  imports: [TranslatePipe, FunnelShellComponent],
  templateUrl: './funnel-check-email-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FunnelCheckEmailPageComponent {
  /** When true, the lead matched a user who already owns a card — we sent a
   *  password-reset / sign-in link instead of the quiz invitation. */
  existingAccount = signal<boolean>(
    !!(history.state && history.state.existingAccount)
  );
}
